import { ref } from 'vue'
import { defineStore } from 'pinia'
import { RESTRICTION, UNDER_DEV } from 'src/common/dictionary'

export const useServerStatusStore = defineStore('server-status', () => {
  const restricted = ref(RESTRICTION.NOT_READY)
  const underDev = ref(UNDER_DEV.NOT_READY)
  const serverIsOk = ref(true)
  const geo = ref({
    country: '',
    client_ip: '',
  })

  function updateServerIsOk(value) {
    serverIsOk.value = value
  }
  function updateRestricted(payload) {
    restricted.value = payload
  }
  function updateUnderDev(payload) {
    underDev.value = payload
  }
  function updateRestrictedGeo(payload) {
    geo.value = payload
  }

  return {
    serverIsOk,
    restricted,
    underDev,
    geo,
    updateServerIsOk,
    updateRestricted,
    updateUnderDev,
    updateRestrictedGeo,
  }
})
